import React, { useEffect } from "react";
import img1 from "../../assets/image/ArVr/imag1.png";
import { FaCheckCircle } from "react-icons/fa";
import img4 from "../../assets/image/ArVr/img4.jpeg";
import img5 from "../../assets/image/ArVr/img5.jpeg";
import img8 from "../../assets/image/ArVr/img8.jpeg";
import "../../assets/css/ArVr.css";
import imgvr from "../../assets/image/ArVr/metaverse_10471142.gif";
import imgar from "../../assets/image/ArVr/vr-glasses_10470892.gif";
import imgvrn from "../../assets/image/ArVr/virtual-reality_19004400.gif";
import imggps from "../../assets/image/ArVr/gps_15968717.gif";
import imgatm from "../../assets/image/ArVr/atm_18818431.gif";
import { Monitor, Lightbulb, Users } from "lucide-react";
import Footer from "../Footer/Footer";
import { useNavigate } from "react-router-dom";
// Import AOS
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import emailjs from "@emailjs/browser";
import { useState, useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";
const ARVRApplicationDevelopment = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const devops = data[0]?.services_page_AR_VR;

    if (devops) {
      setMeta(devops);
    }
  }, []);
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact"); // replace with your actual route
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Animations happen only once
      mirror: false, // Animations don't trigger on scroll up
    });
  }, []);

  const GradientBadge = ({ children }) => (
    <span
      className="badge px-3 py-2 fs-6 fw-normal text-white rounded-pill text-uppercase"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        letterSpacing: "2px",
      }}
    >
      {children}
    </span>
  );

  const features = [
    {
      icon: <Monitor size={40} />,
      title: "Cutting technology",
      description:
        "Every project is customized to fit your unique needs and vision consectetur adipiscing elit.",
    },
    {
      icon: <Lightbulb size={40} />,
      title: "Tailored experiences",
      description:
        "Every project is customized to fit your unique needs and vision consectetur adipiscing elit.",
    },
    {
      icon: <Users size={40} />,
      title: "Expert team",
      description:
        "Every project is customized to fit your unique needs and vision consectetur adipiscing elit.",
    },
  ];

  const cardStyle = {
    border: "2px solid #00b7eb",
    borderRadius: "20px",
    color: "black",
    height: "100%",
    transition: "all 0.3s ease",
  };

  const hoverStyle = {
    transform: "translateY(-10px)",
    boxShadow: "0 20px 40px rgba(91, 4, 4, 0.3)",
  };

  const iconStyle = {
    fontSize: "3rem",
    color: "#00b7eb",
    marginBottom: "1rem",
  };

  const sectionStyle = {
    minHeight: "100vh",
    padding: "80px 0",
    marginTop: "60px",
  };

  const titleStyle = {
    color: "black",
    fontSize: "3.5rem",
    fontWeight: "bold",
    marginBottom: "3rem",
    textAlign: "center",
  };

  const subtitleStyle = {
    color: "#00b7eb",
    fontSize: "1.1rem",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "2px",
    marginBottom: "1rem",
    textAlign: "center",
  };

  const learnMoreStyle = {
    backgroundColor: "transparent",
    border: "2px solid #00b7eb",
    color: "#00b7eb",
    borderRadius: "25px",
    padding: "10px 25px",
    fontWeight: "600",
    transition: "all 0.3s ease",
    marginTop: "2rem",
  };

  const services = [
    {
      id: 1,
      icon: "🎮",
      title: "VR Apps Development",
      description:
        "Build custom Virtual Reality applications for gaming, simulations, and more.",
      bgColor: "bg-primary",
      position: "top-left",
    },
    {
      id: 2,
      icon: "👥",
      title: "AR Business Solutions",
      description:
        "Enhance customer engagement with AR solutions for retail, education, and beyond.",
      bgColor: "bg-primary",
      position: "top-right",
    },
    {
      id: 3,
      icon: "☁️",
      title: "VR Training Simulations",
      description:
        "Build realistic training environments for safe, cost-effective learning experiences.",
      bgColor: "bg-primary",
      position: "bottom-left",
    },
    {
      id: 4,
      icon: "🛒",
      title: "AR Product Visualization",
      description:
        "Enable customers to see and interact with products in their space before purchasing.",
      bgColor: "bg-primary",
      position: "bottom-right",
    },
    {
      id: 5,
      icon: "🧠",
      title: "AI-Powered Experiences",
      description:
        "Integrate artificial intelligence with AR/VR for smarter, more responsive applications.",
      bgColor: "bg-primary",
      position: "center",
    },
  ];

  const learnMoreHoverStyle = {
    color: "white",
    transform: "scale(1.05)",
  };

  const [hoveredCard, setHoveredCard] = React.useState(null);
  const [hoveredButton, setHoveredButton] = React.useState(null);

  const handleReadMore = (serviceName) => {
    console.log(`Read more clicked for: ${serviceName}`);
    // Add your navigation logic here
  };

  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>{meta?.title || "Services-AR/VR - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={meta?.meta?.meta1?.content || "Our curriculum."}
          />
        </Helmet>
        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#00b7eb",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Drone">Drone Solutions</option>
                        <option value="Robotics">Robotics Solutions</option>
                        <option value="IOT">Iot Solutions</option>
                        <option value="AI">Artificial Intelligence</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        {/* <option value="Game">Game Development</option> */}
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        {/* <option value="Casino Api">Casino API</option>
                        <option value="Devops Solutions">DevOps</option>
                        <option value="It Support">IT Support</option> */}
                        <option value="Training Programs">Training</option>
                        {/* <option value="Digital Marketing">
                          Digital Marketing
                        </option> */}
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#00b7eb",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Hero Section */}
        <div
          className="position-relative min-vh-50 arvr-bg d-flex align-items-center justify-content-center bg-dark text-white"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-lg-6 software-content">
                <nav
                  aria-label="breadcrumb"
                  className="mb-4"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      AR/VR Applications Development
                    </li>
                  </ol>
                </nav>
                <h3
                  className="display-6 fw-bold mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  AR/VR Applications Development
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* About Us Section */}
        <div className="container" style={{ marginTop: "30px" }}>
          <div className="row align-items-center">
            <div
              className="col-12 col-lg-8 mb-2 mb-lg-0"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <div
                className="p-4 p-md-2 text-dark fw-semibold"
                style={{ backgroundColor: "#ffffff", color: "#000000" }}
              >
                <button
                  className=" btn border d-flex border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                  style={{ color: "#00b7eb" }}
                >
                  About Us
                </button>
                <h2
                  className="fw-bold mt-3"
                  style={{ fontSize: "48px" }}
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  Experience A New Dimension Of{" "}
                  <span className="font-red">Reality</span>
                </h2>
                <p
                  className=" font-para mt-4 "
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  Augmented reality (AR) and virtual reality (VR) are both
                  technological experiences that change how digital technology
                  interacts with the physical world.
                </p>
                <ul
                  className="list-unstyled mt-4"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <li className="mb-3 fw-medium d-flex align-items-center">
                    <FaCheckCircle className="font-red me-2" />
                    Always put your satisfaction first
                  </li>
                  <li className="mb-3 fw-medium d-flex align-items-center">
                    <FaCheckCircle className="font-red me-2" />
                    The latest and greatest technology
                  </li>
                  <li className="mb-3 fw-medium d-flex align-items-center">
                    <FaCheckCircle className="font-red me-2" />
                    Affordable and guaranteed prices
                  </li>
                </ul>

                <div className="d-flex flex-wrap gap-2 mt-2">
                  <button
                    className="btn btn-red text-white fw-semibold px-4 py-2"
                    onClick={() => setIsOpenEnquiry(true)}
                  >
                    {/* <Code className="me-2" size={18} /> */}
                    Start Your Project
                  </button>
                  {/* <button className="btn btn-red text-white fw-semibold px-4 py-2">
                  View Our Work
                  <ArrowRight className="ms-2" size={18} />
                </button> */}
                </div>
              </div>
            </div>
            <div
              className="col-12 col-lg-4 d-none d-lg-block"
              data-aos="zoom-in"
              data-aos-delay="600"
            >
              <div
                className="position-relative w-100 rounded"
                style={{
                  background:
                    "linear-gradient(90deg, rgb(231, 151, 199) 0%, rgb(183, 53, 195) 40%, rgb(146, 46, 180) 100%)",
                  height: "120%",
                  minHeight: "450px",
                  overflow: "visible",
                  borderRadius: "1rem",
                }}
              >
                <img
                  src={img1}
                  alt="Right side"
                  className="img-fluid position-absolute top-50 start-50 translate-middle"
                  style={{
                    height: "100%",
                    width: "auto",
                    objectFit: "cover",
                    transform: "scale(1.3)",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Immersive Technology Section */}
        <div
          className=" bg-light py-5 mt-5"
          style={{ minHeight: "50vh" }}
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div
            className="min-vh-80 d-flex align-items-center overflow-hidden"
            style={{
              fontFamily: "'Inter', sans-serif",
            }}
          >
            <div
              className="position-absolute w-100 h-100 top-0 start-0"
              style={{ zIndex: 0, pointerEvents: "none" }}
            >
              <div
                className="position-absolute rounded-circle bg-gradient"
                style={{
                  width: "100px",
                  height: "100px",
                  top: "20%",
                  left: "10%",
                  background:
                    "linear-gradient(45deg, rgba(0, 255, 136, 0.1), rgba(0, 102, 255, 0.1))",
                  animation: "float 6s ease-in-out infinite",
                }}
              ></div>
              <div
                className="position-absolute rounded-circle bg-gradient"
                style={{
                  width: "150px",
                  height: "150px",
                  top: "60%",
                  right: "15%",
                  background:
                    "linear-gradient(45deg, rgba(0, 255, 136, 0.1), rgba(0, 102, 255, 0.1))",
                  animation: "float 6s ease-in-out infinite 2s",
                }}
              ></div>
              <div
                className="position-absolute rounded-circle bg-gradient"
                style={{
                  width: "80px",
                  height: "80px",
                  bottom: "30%",
                  left: "5%",
                  background:
                    "linear-gradient(45deg, rgba(0, 255, 136, 0.1), rgba(0, 102, 255, 0.1))",
                  animation: "float 6s ease-in-out infinite 4s",
                }}
              ></div>
            </div>

            <div
              className="container py-2 position-relative"
              style={{ zIndex: 1 }}
            >
              <div className="row align-items-center justify-content-center">
                <div
                  className="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0 order-1 order-lg-1"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <div
                    className="position-relative rounded-3 overflow-hidden shadow-lg mx-auto"
                    style={{
                      boxShadow: "0 20px 60px rgba(0, 102, 255, 0.3)",
                      cursor: "pointer",
                      maxWidth: "400px",
                    }}
                  >
                    <img
                      src={img4}
                      alt="VR Technology"
                      className="w-100 img-fluid"
                      style={{
                        height: "400px",
                        objectFit: "cover",
                        transition: "transform 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.transform = "scale(1)")
                      }
                    />
                    <div
                      className="position-absolute top-0 start-0 w-100 h-100"
                      style={{
                        background:
                          "linear-gradient(45deg, rgba(0, 255, 136, 0.1), rgba(0, 102, 255, 0.1), rgba(255, 0, 153, 0.1))",
                      }}
                    ></div>
                  </div>
                </div>

                <div
                  className="col-12 col-md-12 col-lg-6 text-center my-4 my-lg-0 order-2 order-lg-2 px-3 px-lg-4"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <h3
                    className="display-5 display-lg-5 text-uppercase fw-bold text-dark mb-2 mb-lg-4 tracking-wide"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    ABOUT VARREAL
                  </h3>
                  <h3
                    className="display-6 display-lg-5 text-uppercase fw-bold font-red mb-2 mb-lg-3 tracking-wide"
                    data-aos="fade-up"
                    data-aos-delay="500"
                  >
                    Immersive Technology
                  </h3>
                  <h3
                    className="display-6 display-lg-5 fw-bold mb-3 mb-lg-4"
                    data-aos="fade-up"
                    data-aos-delay="600"
                  >
                    For A Limitless Future
                  </h3>
                  <p
                    className="font-para mb-4 mb-lg-5 mx-auto px-2"
                    data-aos="fade-up"
                    data-aos-delay="700"
                  >
                    Varreal creates seamless AR/VR experiences that transform
                    learning and connections.
                  </p>
                  <button className="btn btn-red text-white fw-semibold px-4 py-2">
                    LEARN MORE
                  </button>
                  <div
                    className="row justify-content-center mt-4 mt-lg-5 pt-2 pt-lg-4"
                    data-aos="fade-up"
                    data-aos-delay="900"
                  >
                    <div className="col-6 col-md-4 mb-3 mb-md-0">
                      <div
                        className="display-5 display-lg-4 fw-bold text-pink"
                        style={{
                          color: "#00b7eb",
                        }}
                      >
                        200K+
                      </div>
                      <div className="text-uppercase font-para text-dark fw-semibold">
                        Development Hours
                      </div>
                    </div>
                    <div className="col-6 col-md-4">
                      <div
                        className="display-5 display-lg-4 fw-bold text-pink"
                        style={{
                          color: "#00b7eb",
                        }}
                      >
                        50K+
                      </div>
                      <div className="text-uppercase font-para text-dark fw-semibold">
                        3D Model Created
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="col-12 col-md-6 col-lg-3 mb-4 mb-lg-0 order-3 order-lg-3"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <div
                    className="position-relative rounded-3 overflow-hidden shadow-lg mx-auto"
                    style={{
                      boxShadow: "0 20px 60px rgba(0, 102, 255, 0.3)",
                      cursor: "pointer",
                      maxWidth: "400px",
                    }}
                  >
                    <img
                      src={img5}
                      alt="Gaming Setup"
                      className="w-100 img-fluid"
                      style={{
                        height: "400px",
                        objectFit: "cover",
                        transition: "transform 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.transform = "scale(1)")
                      }
                    />
                    <div
                      className="position-absolute top-0 start-0 w-100 h-100"
                      style={{
                        background:
                          "linear-gradient(45deg, rgba(0, 255, 136, 0.1), rgba(0, 102, 255, 0.1), rgba(255, 0, 153, 0.1))",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <style>{`
              @import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;900&family=Inter:wght@300;400;500;600;700&display=swap");

              .tracking-wide {
                letter-spacing: 3px;
              }

              @keyframes float {
                0%,
                100% {
                  transform: translateY(0px) rotate(0deg);
                }
                50% {
                  transform: translateY(-20px) rotate(180deg);
                }
              }

              .bg-gradient {
                animation: float 6s ease-in-out infinite;
              }

              .btn-gradient:hover {
                transform: translateY(-3px);
                box-shadow: 0 20px 40px rgba(0, 102, 255, 0.4);
              }

              @media (max-width: 768px) {
                .display-1 {
                  font-size: 2.5rem !important;
                }

                .display-4 {
                  font-size: 2rem !important;
                }
              }
            `}</style>
          </div>
        </div>

        {/* Services Section */}
        <div>
          {/* <div className="container-fluid">
          <div className="container">
            <div
              className="text-center mb-5"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <button
                className=" btn border  border-danger fw-semibold mt-4  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                style={{ color: "#00b7eb" }}
              >
                OUR SERVICES
              </button>
              <h3
                className="display-5 fw-bold text-dark mb-3"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                Transforming Industries With
                <br />
                <span className="font-red">Immersive Technologies</span>
              </h3>
            </div>
            <div className="row g-4">
              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <div
                  className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                  style={{
                    transition: "all 0.3s ease",
                    transform: "translateY(0)",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                  <div className="card-body  position-relative">
                    <div className="d-flex align-items-center ">
                      <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                        <span className="fs-3">
                          <img
                            src={imgvr}
                            alt="Cloud"
                            style={{ width: "3.5em", height: "3.5em" }}
                          />
                        </span>
                      </div>
                      <h5 className="font-card-heading fw-bold mb-0 font-red">
                        VR Apps Development
                      </h5>
                    </div>
                    <p className="font-para  fw-semibold mt-3">
                      Blending digital overlays with real-world contexts for
                      immersive interfaces.
                    </p>
                    <div className="mb-4">
                      
                      <div className="d-flex align-items-center me-4 flex-wrap gap-2">
                        <small className="py-2 px-2 arvr-badge">
                          Intuitive Interface
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Immersive Experience
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Context-aware
                        </small>
                      </div>
                    </div>
                    <button
                      onClick={() => handleReadMore("VR Apps Development")}
                      className="btn text-decoration-none fw-semibold border-0 bg-transparent p-0 mt-3 m"
                      style={{ color: "#00b7eb" }}
                    >
                      READ MORE →
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="500"
               >
                <div
                  className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                  style={{
                    transition: "all 0.3s ease",
                    transform: "translateY(0)",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                  <div className="card-body position-relative">
                    <div className="d-flex align-items-center mb-3">
                      <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                        <span className="fs-3">
                          <img
                            src={imgar}
                            alt="Cloud"
                            style={{ width: "auto", height: "3.5em" }}
                          />
                        </span>
                      </div>
                      <h5 className="font-card-heading fw-bold mb-0 font-red">
                        AR Business Solutions
                      </h5>
                    </div>
                    <p className="font-para text-dark fw-semibold mb-4">
                      Innovative AR-based tools to enhance customer engagement
                      and drive business transformation.
                    </p>
                    <div className="mb-4">
                      
                      <div className="d-flex align-items-center me-4 flex-wrap gap-2">
                        <small className="py-2 px-2 arvr-badge">
                          Real-time Visualization
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Customer Engagement
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          ROI-driven
                        </small>
                      </div>
                    </div>
                    <button
                      onClick={() => handleReadMore("AR Business Solutions")}
                      className="btn text-decoration-none fw-semibold border-0 bg-transparent p-0"
                      style={{ color: "#00b7eb" }}
                    >
                      READ MORE →
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                <div
                  className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                  style={{
                    transition: "all 0.3s ease",
                    transform: "translateY(0)",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                  <div className="card-body  position-relative">
                    <div className="d-flex align-items-center mb-3">
                      <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                        <span className="fs-3">
                          <img
                            src={imgvrn}
                            alt="Cloud"
                            style={{ width: "3.5em", height: "3.5em" }}
                          />
                        </span>
                      </div>
                      <h5 className="font-card-heading fw-bold mb-0 font-red">
                        VR Training Simulations
                      </h5>
                    </div>
                    <p className="font-para text-dark fw-semibold mb-4">
                      Realistic VR simulations for training in healthcare,
                      defense, and corporate industries.
                    </p>
                    <div className="mb-4">

                      <div className="d-flex align-items-center me-4 flex-wrap gap-2">
                        <small className="py-2 px-2 arvr-badge">
                          High Fidelity
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Hands-on Practice
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Risk-free Learning
                        </small>
                      </div>
                    </div>
                    <a
                      href="#"
                      className="text-decoration-none fw-semibold"
                      style={{ color: "#00b7eb" }}
                    >
                      READ MORE →
                    </a>
                  </div>
                </div>
              </div>






              <div className="d-flex justify-content-center flex-wrap gap-4">
               
                            <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                <div
                  className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                  style={{
                    transition: "all 0.3s ease",
                    transform: "translateY(0)",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                  <div className="card-body  position-relative">
                    <div className="d-flex align-items-center mb-3">
                    


                       <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                          <span className="fs-3">
                            <img
                              src={imggps}
                              alt="Cloud"
                              style={{ width: "3.5em", height: "3.5em" }}
                            />
                          </span>
                        </div>
                      <h5 className="font-card-heading fw-bold mb-0 font-red">
                          AR Navigation Systems
                        </h5>
                    </div>
                     <p className="font-para text-dark fw-semibold mb-4">
                        Augmented navigation that overlays directions, markers,
                        and live updates for improved mobility.
                      </p>
                      <div className="mb-4 d-flex align-items-center flex-wrap gap-2">
                        <small className="py-2 px-2 arvr-badge">
                          Indoor/Outdoor Routing
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Real-time Guidance
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Voice + Visual Cues
                        </small>
                      </div>
                    <a
                      href="#"
                      className="text-decoration-none fw-semibold"
                      style={{ color: "#00b7eb" }}
                    >
                      READ MORE →
                    </a>
                  </div>
                </div>
              </div>
               

                
                <div
                  data-aos="fade-up"
                  data-aos-delay="800"
                  style={{ maxWidth: "400px", flex: "300px" }}
                >
                  <div
                    className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                    style={{
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-10px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                    <div className="card-body p-2 position-relative">
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                          <span className="fs-3">
                            <img
                              src={imgatm}
                              alt="Cloud"
                              style={{ width: "3.5em", height: "3.5em" }}
                            />
                          </span>
                        </div>
                        <h5 className="font-card-heading fw-bold mb-0 font-red">
                          Virtual Showrooms
                        </h5>
                      </div>
                      <p className="font-para text-dark fw-semibold mb-4">
                        Enable customers to explore products in immersive 3D
                        environments from any location.
                      </p>
                      <div className="mb-4 d-flex align-items-center flex-wrap gap-2">
                        <small className="py-2 px-2 arvr-badge">
                          Live Chat Support
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Customizable Layouts
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          360° Product Views
                        </small>
                      </div>
                      <a
                        href="#"
                        className="text-decoration-none fw-semibold"
                        style={{ color: "#00b7eb" }}
                      >
                        READ MORE →
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
          <div className="container-fluid">
            <div className="container">
              <div
                className="text-center mb-5"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <button
                  className=" btn border  border-danger fw-semibold mt-4  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                  style={{ color: "#00b7eb" }}
                >
                  OUR SERVICES
                </button>
                <h3
                  className="display-5 fw-bold text-dark mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  Transforming Industries With
                  <br />
                  <span className="font-red">Immersive Technologies</span>
                </h3>
              </div>
              <div className="row g-4">
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div
                    className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                    style={{
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-10px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                    <div className="card-body  position-relative">
                      <div className="d-flex align-items-center ">
                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                          <span className="fs-3">
                            <img
                              src={imgvr}
                              alt="Cloud"
                              style={{ width: "3.5em", height: "3.5em" }}
                            />
                          </span>
                        </div>
                        <h5 className="font-card-heading fw-bold mb-0 font-red">
                          VR Apps Development
                        </h5>
                      </div>
                      <p className="font-para  fw-semibold mt-3">
                        Blending digital overlays with real-world contexts for
                        immersive interfaces.
                      </p>
                      <div className="mb-4">
                        <div className="d-flex align-items-center me-4 flex-wrap gap-2">
                          <small className="py-2 px-2 arvr-badge">
                            Intuitive Interface
                          </small>
                          <small className="py-2 px-2 arvr-badge">
                            Immersive Experience
                          </small>
                          <small className="py-2 px-2 arvr-badge">
                            Context-aware
                          </small>
                        </div>
                      </div>
                      <button
                        onClick={() => handleReadMore("VR Apps Development")}
                        className="btn text-decoration-none fw-semibold border-0 bg-transparent p-0 mt-3 m"
                        style={{ color: "#00b7eb" }}
                      >
                        READ MORE →
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <div
                    className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                    style={{
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-10px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                    <div className="card-body position-relative">
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                          <span className="fs-3">
                            <img
                              src={imgar}
                              alt="Cloud"
                              style={{ width: "auto", height: "3.5em" }}
                            />
                          </span>
                        </div>
                        <h5 className="font-card-heading fw-bold mb-0 font-red">
                          AR Business Solutions
                        </h5>
                      </div>
                      <p className="font-para text-dark fw-semibold mb-4">
                        Innovative AR-based tools to enhance customer engagement
                        and drive business transformation.
                      </p>
                      <div className="mb-4">
                        <div className="d-flex align-items-center me-4 flex-wrap gap-2">
                          <small className="py-2 px-2 arvr-badge">
                            Real-time Visualization
                          </small>
                          <small className="py-2 px-2 arvr-badge">
                            Customer Engagement
                          </small>
                          <small className="py-2 px-2 arvr-badge">
                            ROI-driven
                          </small>
                        </div>
                      </div>
                      <button
                        onClick={() => handleReadMore("AR Business Solutions")}
                        className="btn text-decoration-none fw-semibold border-0 bg-transparent p-0"
                        style={{ color: "#00b7eb" }}
                      >
                        READ MORE →
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="600"
                >
                  <div
                    className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                    style={{
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-10px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                    <div className="card-body  position-relative">
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                          <span className="fs-3">
                            <img
                              src={imgvrn}
                              alt="Cloud"
                              style={{ width: "3.5em", height: "3.5em" }}
                            />
                          </span>
                        </div>
                        <h5 className="font-card-heading fw-bold mb-0 font-red">
                          VR Training Simulations
                        </h5>
                      </div>
                      <p className="font-para text-dark fw-semibold mb-4">
                        Realistic VR simulations for training in healthcare,
                        defense, and corporate industries.
                      </p>
                      <div className="mb-4">
                        <div className="d-flex align-items-center me-4 flex-wrap gap-2">
                          <small className="py-2 px-2 arvr-badge">
                            High Fidelity
                          </small>
                          <small className="py-2 px-2 arvr-badge">
                            Hands-on Practice
                          </small>
                          <small className="py-2 px-2 arvr-badge">
                            Risk-free Learning
                          </small>
                        </div>
                      </div>
                      <a
                        href="#"
                        className="text-decoration-none fw-semibold"
                        style={{ color: "#00b7eb" }}
                      >
                        READ MORE →
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="600"
                >
                  <div
                    className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                    style={{
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-10px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                    <div className="card-body  position-relative">
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                          <span className="fs-3">
                            <img
                              src={imggps}
                              alt="Cloud"
                              style={{ width: "3.5em", height: "3.5em" }}
                            />
                          </span>
                        </div>
                        <h5 className="font-card-heading fw-bold mb-0 font-red">
                          AR Navigation Systems
                        </h5>
                      </div>
                      <p className="font-para text-dark fw-semibold mb-4">
                        Augmented navigation that overlays directions, markers,
                        and live updates for improved mobility.
                      </p>
                      <div className="mb-4 d-flex align-items-center flex-wrap gap-2">
                        <small className="py-2 px-2 arvr-badge">
                          Indoor/Outdoor Routing
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Real-time Guidance
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Voice + Visual Cues
                        </small>
                      </div>
                      <a
                        href="#"
                        className="text-decoration-none fw-semibold"
                        style={{ color: "#00b7eb" }}
                      >
                        READ MORE →
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="800"
                >
                  <div
                    className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                    style={{
                      transition: "all 0.3s ease",
                      transform: "translateY(0)",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-10px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
                    <div className="card-body p-2 position-relative">
                      <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3">
                          <span className="fs-3">
                            <img
                              src={imgatm}
                              alt="Cloud"
                              style={{ width: "3.5em", height: "3.5em" }}
                            />
                          </span>
                        </div>
                        <h5 className="font-card-heading fw-bold mb-0 font-red">
                          Virtual Showrooms
                        </h5>
                      </div>
                      <p className="font-para text-dark fw-semibold mb-4">
                        Enable customers to explore products in immersive 3D
                        environments from any location.
                      </p>
                      <div className="mb-4 d-flex align-items-center flex-wrap gap-2">
                        <small className="py-2 px-2 arvr-badge">
                          Live Chat Support
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          Customizable Layouts
                        </small>
                        <small className="py-2 px-2 arvr-badge">
                          360° Product Views
                        </small>
                      </div>
                      <a
                        href="#"
                        className="text-decoration-none fw-semibold"
                        style={{ color: "#00b7eb" }}
                      >
                        READ MORE →
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <style>{`
            .letter-spacing-2 {
              letter-spacing: 2px;
            }
            .card {
              transition: transform 0.3s ease, box-shadow 0.3s ease;
            }
            .card:hover {
              transform: translateY(-5px);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
            }
            .text-white-50 {
              color: rgba(255, 255, 255, 0.7) !important;
            }
          `}</style>

          {/* Call to Action Section */}
          <div style={{ marginTop: "60px" }}>
            <link
              href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
              rel="stylesheet"
            />
            <section
              className="position-relative min-vh-50 d-flex align-items-center justify-content-center py-3"
              style={{
                background: `url(${img8})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
              }}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="position-absolute top-0 start-0 w-100 h-70" />
              <div className="container position-relative z-1">
                <div className="row justify-content-center">
                  <div
                    className="col-lg-10 col-xl-8 text-center"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <h3
                      className="display-5 text-white fw-bold mb-2"
                      data-aos="fade-up"
                      data-aos-delay="300"
                    >
                      Step Into the Future — Transform Your
                    </h3>
                    <h3
                      className="display-5 text-white fw-bold mb-5"
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      Business with AR & VR
                    </h3>
                    <p
                      className="text-white font-para  fw-semibold mb-5 mx-auto"
                      data-aos="fade-up"
                      data-aos-delay="500"
                    >
                      Step into immersive worlds that blend the virtual with
                      reality, explore environments beyond imagination, and
                      interact like never before with the power of Augmented and
                      Virtual Reality.
                    </p>
                    <div
                      className="d-flex justify-content-center"
                      data-aos="zoom-in"
                      data-aos-delay="600"
                    >
                      <button
                        className="btn btn-red text-white fw-semibold px-4 py-2"
                        onClick={handleContactClick}
                      >
                        Contact Us
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
                <div
                  className="position-absolute"
                  style={{
                    top: "20%",
                    left: "10%",
                    width: "4px",
                    height: "4px",
                    background: "#6366f1",
                    borderRadius: "50%",
                    animation: "float 6s ease-in-out infinite",
                    boxShadow: "0 0 10px #6366f1",
                  }}
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "60%",
                    right: "15%",
                    width: "6px",
                    height: "6px",
                    background: "#a855f7",
                    borderRadius: "50%",
                    animation: "float 8s ease-in-out infinite reverse",
                    boxShadow: "0 0 15px #a855f7",
                  }}
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "40%",
                    left: "80%",
                    width: "3px",
                    height: "3px",
                    background: "#c084fc",
                    borderRadius: "50%",
                    animation: "float 7s ease-in-out infinite",
                    boxShadow: "0 0 8px #c084fc",
                  }}
                />
              </div>
            </section>
            <style>{`
              @import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap");

              @keyframes float {
                0%,
                100% {
                  transform: translateY(0px);
                }
                50% {
                  transform: translateY(-20px);
                }
              }

              .z-1 {
                z-index: 1;
              }

              .btn:focus {
                box-shadow: 0 0 0 0.25rem rgba(99, 102, 241, 0.25) !important;
              }

              @media (max-width: 768px) {
                .display-3 {
                  font-size: 2.5rem !important;
                }

                .display-4 {
                  font-size: 2rem !important;
                }

                .lead {
                  font-size: 1.1rem !important;
                }

                .btn-lg {
                  padding: 0.75rem 2rem !important;
                  fontsize: 0.9rem !important;
                }
              }

              @media (max-width: 576px) {
                .display-3 {
                  font-size: 2rem !important;
                }

                .display-4 {
                  font-size: 1.75rem !important;
                }

                .container {
                  padding-left: 1rem;
                  padding-right: 1rem;
                }
              }

              @supports (-webkit-background-clip: text) {
                .gradient-text {
                  background: linear-gradient(
                    135deg,
                    #c084fc 0%,
                    #a855f7 50%,
                    #9333ea 100%
                  );
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  background-clip: text;
                }
              }
            `}</style>
          </div>
        </div>
        <Footer data-aos="fade-up" data-aos-delay="100" />
      </div>
    </HelmetProvider>
  );
};

export default ARVRApplicationDevelopment;
